<div class="www-my-data">
  <section class="container www-my-data__con">
    <div class="www-my-data__con__sec">
      <app-expander [initialOpen]="true" [title]="'Moje korzyści u partnerów'">
        <app-partners-benefits (openDetails)="openPartnerCodeDetailsModal($event)" [partnersCodes]="partnerCodes()" />
      </app-expander>
    </div>

    <!-- <div class="www-my-data__con__sec">
      <app-expander [title]="'MÓJ CEL I NAGRODA'" [initialOpen]="initialExpanderOpen()">
        <app-target-multibrand />
      </app-expander>
    </div> -->

    <!-- <div class="www-my-data__con__sec">
      <app-expander [title]="'KODY RABATOWE'">
        <app-discount-codes />
      </app-expander>
    </div> -->

    <div class="www-my-data__con__sec">
      <app-expander [title]="'Moje rezerwacje'">
        <app-payment-history />
      </app-expander>
    </div>

    <div class="www-my-data__con__sec">
      <app-expander [title]="'DANE PODSTAWOWE'">
        <div class="www-my-data__con__sec__row">
          <div class="www-my-data__con__sec__col">
            <h3 class="www-my-data__con__sec__sub-tit">DANE SALONU</h3>
            <form
              [formGroup]="formGroup"
              [ngxsFormClearOnDestroy]="_isBrowser"
              [ngxsFormDebounce]="20"
              [ngxsForm]="'myData.form'"
              class="www-form www-form-disabled www-my-data__sec__form"
              appInvalidControlScroll
              [appAnimate]="'fadeInLeft'"
              [speed]="'fast'"
            >
              <div class="row">
                <div class="col-12">
                  <div class="group">
                    <input
                      [appInputValidator]="f.name"
                      [formControlName]="'name'"
                      id="name"
                      type="text"
                      autocomplete="off"
                    />
                    <label class="www-form-disabled__dis" for="name">Nazwa</label>
                  </div>
                  <app-validate-message [control]="f.name" />
                </div>

                <div class="col-12">
                  <div class="group">
                    <input class="used" [formControlName]="'nip'" id="nip" type="text" />
                    <label class="www-form-disabled__dis" for="nip">NIP</label>
                  </div>
                </div>

                <div class="col-12">
                  <div class="group">
                    <input class="used" [formControlName]="'street'" id="street" type="text" />
                    <label class="www-form-disabled__dis" for="street">Ulica</label>
                  </div>
                </div>

                <div class="col-12">
                  <div class="group">
                    <input class="used" [formControlName]="'zipCode'" id="zip_code" type="text" />
                    <label class="www-form-disabled__dis" for="zip_code">Kod pocztowy</label>
                  </div>
                </div>

                <div class="col-12">
                  <div class="group">
                    <input class="used" [formControlName]="'city'" id="city" type="text" />
                    <label class="www-form-disabled__dis" for="city">Miejscowość</label>
                  </div>
                </div>
              </div>
            </form>

            <div class="www-my-data__con__sec__col">
              <h3 class="www-my-data__con__sec__sub-tit">DANE DO LOGOWANIA</h3>

              <form
                [formGroup]="formGroup"
                [ngxsFormClearOnDestroy]="_isBrowser"
                [ngxsFormDebounce]="20"
                [ngxsForm]="'myData.form'"
                class="www-form www-form-disabled www-my-data__sec__form"
                appInvalidControlScroll
                [appAnimate]="'fadeInLeft'"
                [speed]="'fast'"
              >
                <div class="row">
                  <div class="col-12">
                    <div class="group">
                      <input
                        [appInputValidator]="f.firstname"
                        [formControlName]="'firstname'"
                        id="firstname"
                        type="text"
                        autocomplete="off"
                      />
                      <label class="www-form-disabled__dis" for="firstname">Imię</label>
                    </div>
                    <app-validate-message [control]="f.firstname" />
                  </div>

                  <div class="col-12">
                    <div class="group">
                      <input class="used" [formControlName]="'lastname'" id="lastname" type="text" />
                      <label class="www-form-disabled__dis" for="lastname">Nazwisko</label>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="group">
                      <input
                        [appInputValidator]="f.mobile"
                        [formControlName]="'mobile'"
                        id="mobile"
                        type="text"
                        autocomplete="off"
                        [mask]="'00 000 000 000'"
                      />
                      <label class="www-form-disabled__dis" for="mobile">Nr telefonu</label>
                    </div>
                    <app-validate-message [control]="f.mobile" />
                  </div>

                  <div class="col-12">
                    <div class="group">
                      <input
                        [appInputValidator]="f.email"
                        [formControlName]="'email'"
                        id="email"
                        type="text"
                        autocomplete="off"
                      />
                      <label class="www-form-disabled__dis" for="email">Adres e-mail</label>
                    </div>
                    <app-validate-message [control]="f.email" />
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div style="flex-basis: 100%">
            <div class="www-my-data__con__sec__tip">
              <p class="www-my-data__con__sec__tip__tit">Dane uległy zmianie?</p>

              <p class="www-my-data__con__sec__tip__des">
                Jeśli zmieniły się dane firmy, adres, nazwa, numer NIP lub osoba reprezentująca firmę w Programie
                <br class="d-none d-md-inline" />
                prosimy o kontakt z naszym działem Wsparcia
                <br /><br />
                <a
                  [routerLink]="['/', WwwRouteSlug.CONTACT]"
                  appGtmClick
                  [layer]="{
                    event: 'uaevent',
                    ecommerce: 'undefined',
                    eventCategory: 'user data page',
                    eventAction: 'select::go to contact form',
                    eventLabel: 'go to contact form::' + '/' + WwwRouteSlug.CONTACT,
                    event_name: 'body_button_click',
                    module_name: 'go to contact form',
                    cta_name: 'go to contact form',
                    link_url: '/' + WwwRouteSlug.CONTACT,
                  }"
                >
                  Przejdź do formularza kontaktowego <img alt="link" src="assets/images/pages/my-data/link.png" />
                </a>
              </p>
            </div>
          </div>
        </div>
      </app-expander>
    </div>

    <div class="www-my-data__con__sec">
      <app-expander [title]="'zgody marketingowe'">
        <app-agreements></app-agreements>
      </app-expander>
    </div>
  </section>
</div>
